import React from 'react';
import {FormBlock} from 'api';
import TextBlock from './Text';
import ButtonBlock from './Button';
import ImageBlock from './Image';
import PersonalInformatinBlock from './PersonalInformation';
import SubmitButtonBlock from './SubmitButton';
import StandardFieldBlock from './StandardField';
import CustomizeItemFieldBlock from './CustomizeItemField';
import OtherItemFieldBlock from './OtherField';

const blockComponents: {[key: string]: any} = {
  FormBlockText: TextBlock,
  FormBlockButton: ButtonBlock,
  FormBlockImage: ImageBlock,
  FormBlockPersonalInformation: PersonalInformatinBlock,
  FormBlockSubmitButton: SubmitButtonBlock,
  FormBlockFieldStandard: StandardFieldBlock,
  FormBlockFieldCustomizeItem: CustomizeItemFieldBlock,
  FormBlockFieldOther: OtherItemFieldBlock,
};

interface Props {
  block: FormBlock;
}

export default ({block}: Props) => {
  const BlockComponent = blockComponents[block.formBlockable.__typename];

  if (!BlockComponent) return null;

  return <BlockComponent block={block} />;
};
